import React from 'react';
import { Button, Box } from '@mui/material';
import MaterialReactTable, { MRT_ColumnDef } from 'material-react-table';
import { EmissionAllocation } from 'api';
import { COLORS } from 'components';

interface AllocationSetupsTableProps {
    data: EmissionAllocation[];
    columns: MRT_ColumnDef<EmissionAllocation>[];
    onViewDetails: (allocationId: number) => void;
}

export const AllocationSetupsTable = ({ data, columns, onViewDetails }: AllocationSetupsTableProps) => (
    <Box sx={{ mt: '20px', width: '100%' }}>
        {data?.length > 0 ? (
            <MaterialReactTable
                enableTopToolbar
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                data={data}
                enablePagination={false}
                columns={columns}
                enableRowVirtualization
                enableStickyHeader
                enableColumnFilters
                initialState={{ density: 'compact' }}
                enableRowActions
                positionActionsColumn="last"
                renderRowActions={({ row }: any) => (
                    <Button
                        variant="text"
                        sx={{ paddingLeft: 0 }}
                        onClick={() => onViewDetails(row.original.allocationId)}
                        aria-label={`View details for allocation ${row.original.allocationId}`}
                    >
                        See Details
                    </Button>
                )}
                muiTableContainerProps={{
                    sx: {
                        width: '100%',
                        maxWidth: '100%',
                        height: 'calc(100vh - 390px)',
                        minHeight: "200px",
                        border: '1px solid #D9D9D9',
                        borderRadius: '10px',
                        overflowX: 'auto',
                    },
                }}
                muiTablePaperProps={{
                    sx: {
                        borderRadius: '10px',
                        boxShadow: 'none',
                        width: '100%',
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        color: COLORS.Romance,
                        height: '44px',
                        paddingLeft: '34px',
                        '&:last-child': {
                            paddingRight: '16px',
                        },
                        '& .MuiBadge-root': {
                            display: 'none',
                        },
                    },
                }}
                muiTableBodyCellProps={{
                    sx: {
                        height: '44px',
                        paddingLeft: '34px',
                        '&:last-child': {
                            paddingRight: '16px',
                        },
                    },
                }}
                muiTableHeadRowProps={{
                    sx: {
                        '& > th': {
                            paddingTop: 1,
                            paddingBottom: 1,
                        },
                    },
                }}
                muiTopToolbarProps={{
                    sx: {
                        height: '1px',
                        minHeight: '1px',
                        backgroundColor: 'transparent',
                        '& .MuiIconButton-root': {
                            display: 'none',
                        },
                    },
                }}
                muiBottomToolbarProps={{
                    sx: {
                        display: "none",
                    },
                }}
                muiTableBodyRowProps={({ row }: any) => ({
                    onClick: () => onViewDetails(row.original.allocationId),
                    sx: { cursor: 'pointer', backgroundColor: 'transparent' },
                })}
                getRowId={(row) => String(row.allocationId)}
                muiTableProps={{
                    sx: {
                        tableLayout: 'auto',
                        whiteSpace: 'nowrap',
                    },
                }}
            />
        ) : (
            <Box sx={{ textAlign: 'center', padding: '20px', color: 'text.secondary' }}>
                No allocation setups available.
            </Box>
        )}
    </Box>
);